import { LoadingButton } from "@mui/lab";
import { Button, Grid } from "@mui/material";
import React, { useState } from "react";

const FilterModalHeaderSection = ({ handleFilter, resetFilter, loading }) => {
  // const [loading, setLoading] = useState(false);
  return (
    <Grid
      container
      alignItems={"center"}
      style={{ paddingTop: 20, paddingLeft: 10 }}
    >
      <Grid item container xs>
        <div
          onClick={() =>
            resetFilter ? resetFilter() : console.log("do nothing")
          }
          style={resetTextStyles}
        >
          Reset
        </div>
      </Grid>
      <Grid item container xs justifyContent={"center"}>
        <div style={filterTextStyles}>Filter</div>
      </Grid>
      <Grid item container xs justifyContent={"flex-end"}>
        <LoadingButton
          variant="text"
          style={applyButtonStyles}
          loading={loading}
          onClick={handleFilter}
        >
          Apply
        </LoadingButton>
      </Grid>
    </Grid>
  );
};

export default FilterModalHeaderSection;

const applyButtonStyles = {
  height: 30,
  textTransform: "none",
  color: "#00A7CD",
  fontSize: 16,
  fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};

const filterTextStyles = {
  color: "#020303",
  fontSize: 22,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
};

const resetTextStyles = {
  color: "#020303",
  fontSize: 16,
  fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
  cursor: "pointer",
};
